import React from 'react';
import { Stepper, Step, StepLabel, Grid, StepConnector } from '@material-ui/core';
import { makeStyles, withStyles, withTheme } from '@material-ui/core/styles';

const CustomConnector = withStyles(theme => ({
    alternativeLabel: {
        top: 8,
        left: '-50%',
        right: '50%'
    },
    active: {
        '& $line': {
            backgroundColor: theme.palette.primary.main
        }
    },
    completed: {
        '& $line': {
            backgroundColor: theme.palette.primary.main
        }
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#ccc',
        borderRadius: 1
    }
}))(StepConnector);

function CustomStepIcon({ active, completed }) {
    const classes = makeStyles(theme => ({
        root: {
            backgroundColor: '#cccccc',
            zIndex: 1,
            color: '#fff',
            width: 18,
            height: 18,
            display: 'flex',
            borderRadius: '50%',
            justifyContent: 'center',
            alignItems: 'center'
        },
        active: {
            backgroundColor: theme.palette.primary.main
        },
        completed: {
            backgroundColor: theme.palette.primary.main
        }
    }));
    return (
        <div
            className={`${classes.root} ${active ? classes.active : ''} ${
                completed ? classes.completed : ''
            }`}
        />
    );
}

const BookingProgressBar = ({ activeStep = 0 }) => {
    const steps = ['Review', 'Cart', 'Payment', 'Confirmation'];
    const labelClasses = makeStyles({
        label: {
            '& span:nth-child(2) span': {
                marginTop: 7
            }
        }
    });
    return (
        <Grid
            className="booking-progress-container"
            item
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
        >
            <Stepper
                className="booking-progress"
                style={{ width: '100%', padding: '16px' }}
                alternativeLabel
                activeStep={activeStep}
                connector={<CustomConnector />}
            >
                {steps.map(label => (
                    <Step key={label}>
                        <StepLabel
                            className={labelClasses.label}
                            StepIconComponent={CustomStepIcon}
                        >
                            {label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Grid>
    );
};

export default withTheme(BookingProgressBar);
